import { css } from '@emotion/react'
import { colors, font } from 'plume-ui'
import React from 'react'
import { Shareholder } from '../../../../../types/api'
import { LineClamp } from '../../../../atoms/LineClamp'
import {
  SummaryLabel,
  SummaryLabelAnnotation,
} from '../domestic/CompanySummary'

type Props = {
  shareholders: Shareholder[]
}

export const Shareholders: React.VFC<Props> = (props) => {
  const leads = props.shareholders
    .filter((s) => s.lead)
    .map((s) => s.name)
    .sort()
  const notLeads = props.shareholders
    .filter((s) => !s.lead)
    .map((s) => s.name)
    .sort()
  const shareholders = leads.concat(notLeads)

  return (
    <div>
      <SummaryLabel>
        株主
        <SummaryLabelAnnotation>（過去の株主を含む）</SummaryLabelAnnotation>
      </SummaryLabel>
      <LineClamp
        className="shareholders"
        lineNumber={3}
        title={shareholders.join(' / ')}
        css={css`
          font-style: normal;
          font-weight: ${font.weight.normal};
          font-size: 14px;
          line-height: 150%;
          color: ${colors.black30};
          text-decoration: none;
          cursor: default;
        `}
      >
        {shareholders.map((s, i) => (
          <span key={s} className="shareholder">
            {i !== 0 && <ShareholderDivider />}
            {s}
          </span>
        ))}
      </LineClamp>
    </div>
  )
}

const ShareholderDivider: React.VFC = () => (
  <span
    css={css`
      color: ${colors.textLight};
    `}
  >
    {' / '}
  </span>
)
